import { fetchTaskManagerDetails } from "../dashboard2/dashboardApi";
import {
  emptyQueueSummary,
  mapQueueWorkItem,
  summarizeLanes,
} from "./queueModel";

function listBody(statusList, taskTypeList, pageSize) {
  return {
    pageNo: 0,
    pageSize: pageSize || 1,
    sortOrder: "desc",
    sortColumn: "created_on",
    tableName: "task_manager",
    statusList: statusList || [],
    priorityList: [],
    actionList: [],
    taskTypeList: taskTypeList || [],
    searchtext: "",
  };
}

export function fetchOpenQueueRows() {
  return fetchTaskManagerDetails(listBody(["Open", "InProgress"], [], 250));
}

export function fetchCompletedQueueRows() {
  return fetchTaskManagerDetails(listBody(["Complete"], [], 100));
}

var PRIORITY_RANK = { high: 0, normal: 1, low: 2 };

function priorityRank(value) {
  var rank = PRIORITY_RANK[String(value || "").toLowerCase()];
  return rank == null ? 3 : rank;
}

export function buildMyQueue(rows, viewer, now) {
  var current = now || new Date();
  var items = (rows || [])
    .map(function (row) {
      return mapQueueWorkItem(row, current);
    })
    .filter(Boolean);
  items.forEach(function (item) {
    var mine =
      viewer &&
      viewer.id &&
      item.assigneeId &&
      String(viewer.id) === String(item.assigneeId);
    item.assignedToViewer = Boolean(mine);
    item.attention =
      Boolean(mine) &&
      item.lane !== "completed" &&
      item.lane !== "due_today";
  });
  items.sort(function (left, right) {
    var byPriority = priorityRank(left.priority) - priorityRank(right.priority);
    if (byPriority !== 0) return byPriority;
    return (right.ageMs || 0) - (left.ageMs || 0);
  });
  return {
    items: items,
    summary: summarizeLanes(items),
  };
}

var QUEUE_CACHE_MS = 15000;
var queueInflight = {};
var queueCache = {};

export function invalidateQueueCache() {
  queueCache = {};
  queueInflight = {};
}

function cachedQueue(key, loader) {
  var nowMs = Date.now();
  var hit = queueCache[key];
  if (hit && nowMs - hit.at < QUEUE_CACHE_MS) {
    return Promise.resolve(hit.value);
  }
  if (queueInflight[key]) {
    return queueInflight[key];
  }
  queueInflight[key] = loader()
    .then(function (value) {
      queueCache[key] = { at: Date.now(), value: value };
      queueInflight[key] = null;
      return value;
    })
    .catch(function (err) {
      queueInflight[key] = null;
      throw err;
    });
  return queueInflight[key];
}

function isCompletedToday(item, current) {
  var stamp = item.createdAt || item.dueDate;
  if (!stamp) return true;
  var created = new Date(stamp);
  if (isNaN(created.getTime())) return true;
  return (
    created.getFullYear() === current.getFullYear() &&
    created.getMonth() === current.getMonth() &&
    created.getDate() === current.getDate()
  );
}

function mergeSummaries(openSummary, completedToday) {
  var summary = emptyQueueSummary();
  var open = openSummary || emptyQueueSummary();
  summary.new_orders = open.new_orders || 0;
  summary.delivery_change = open.delivery_change || 0;
  summary.due_today = open.due_today || 0;
  summary.exceptions = open.exceptions || 0;
  summary.completed = completedToday.length;
  summary.urgent = open.urgent || 0;
  summary.deliveryChange = open.deliveryChange || 0;
  summary.exception = open.exception || 0;
  summary.dueToday = open.dueToday || 0;
  summary.total =
    summary.new_orders +
    summary.delivery_change +
    summary.due_today +
    summary.exceptions;
  return summary;
}

export function loadQueueSummary(viewer, now, options) {
  if (options && options.force) {
    invalidateQueueCache();
  }
  return cachedQueue("full", function () {
    var current = now || new Date();
    return Promise.all([
      fetchOpenQueueRows(),
      fetchCompletedQueueRows().catch(function () {
        return { results: [] };
      }),
    ]).then(function (parts) {
      var openBuilt = buildMyQueue(parts[0] && parts[0].results, viewer, current);
      var doneBuilt = buildMyQueue(parts[1] && parts[1].results, viewer, current);
      var completedToday = doneBuilt.items.filter(function (item) {
        return isCompletedToday(item, current);
      });
      var summary = mergeSummaries(openBuilt.summary, completedToday);
      return {
        items: openBuilt.items.concat(completedToday),
        summary: summary,
      };
    });
  });
}

export function loadQueueCounts(viewer, now) {
  return cachedQueue("counts", function () {
    return loadQueueSummary(viewer, now).then(function (result) {
      return {
        items: [],
        summary: (result && result.summary) || emptyQueueSummary(),
      };
    });
  });
}



// WEBPACK FOOTER //
// ./src/components/workflowQueue/queueApi.js